import step1 from './images/hostaway_step1.jpg';
import step2 from './images/hostaway_step2.jpg';
import step3 from './images/hostaway_step3.jpg';
import step4 from './images/hostaway_step4.jpg';
import step5 from './images/hostaway_step5.jpg';
import step6 from './images/hostaway_step6.jpg';
import step7 from './images/hostaway_step7.jpg';
import step8 from './images/hostaway_step8.jpg';
import step9 from './images/hostaway_step9.jpg';
import step10 from './images/hostaway_step10.jpg';
import lodgify_step1 from './images/lodgify_step1.jpg';
import lodgify_step2 from './images/lodgify_step2.jpg';
import ownerrez_step1 from './images/ownerrez_step1.jpg';
import ownerrez_step2 from './images/ownerrez_step2.jpg';
import ownerrez_step3 from './images/ownerrez_step3.jpg';
import ownerrez_step4 from './images/ownerrez_step4.jpg';
import ownerrez_step5 from './images/ownerrez_step5.jpg';
import ownerrez_step6 from './images/ownerrez_step6.jpg';
import ownerrez_step7 from './images/ownerrez_step7.jpg';

const hostawayStepByStepInstructions = {
  step1,
  step2,
  step3,
  step4,
  step5,
  step6,
  step7,
  step8,
  step9,
  step10,
};

export { hostawayStepByStepInstructions };

const lodgifyStepByStepInstructions = {
  lodgify_step1,
  lodgify_step2,
};

export { lodgifyStepByStepInstructions };

const ownerrezStepByStepInstructions = {
  ownerrez_step1,
  ownerrez_step2,
  ownerrez_step3,
  ownerrez_step4,
  ownerrez_step5,
  ownerrez_step6,
  ownerrez_step7,
};

export { ownerrezStepByStepInstructions };
